import * as ActionTypes from '../ReduxConstants/ServiceActionConstants';

export const getMSRStatus = () => (dispatch) => {
    dispatch({
        type: ActionTypes.MSR_FLOW, 
    });
};

